import { HeaderContent } from './types';

export enum AuthKey {
  AUTHORIZATION = 'Authorization'
}
export enum AuthType {
  BEARER = 'Bearer'
}

class Header {
  public header: HeaderContent;

  constructor() {
    this.header = {};
  }

  updateToken(authKey: AuthKey, authType: AuthType, token: string): void {
    this.header = {
      ...this.header,
      [authKey]: `${authType} ${token}`
    };
  }

  removeToken(authKey: AuthKey): void {
    if (authKey in this.header) {
      delete this.header[authKey];
    }
  }
}

export default Header;
